import { render, staticRenderFns } from "./DeleteClassList.vue?vue&type=template&id=d93d13f6"
import script from "./DeleteClassList.vue?vue&type=script&lang=js"
export * from "./DeleteClassList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports